// src/components/fotosSobre.js
// Fotos da página Sobre, com licença livre no Wikimedia Commons. Os arquivos
// ficam em public/sobre/ (créditos completos em public/sobre/credits.json).
const BASE = process.env.PUBLIC_URL;

export const FOTO_CAPA = {
  src: `${BASE}/sobre/camara-de-curitiba-vista-aerea.jpg`,
  alt: "Vista aérea da Câmara Municipal de Curitiba, cercada pelos prédios do centro e por avenidas movimentadas",
  credito: "Câmara Municipal de Curitiba vista do alto, Rodrigo Fonseca/CMC, domínio público",
  pagina: "https://commons.wikimedia.org/wiki/File:Camara_de_Curitiba_vista_a%C3%A9rea.jpg",
};

export const FOTO_CIDADE = {
  src: `${BASE}/sobre/neoville-fotoaerea-1.jpg`,
  alt: "Foto aérea do loteamento Neoville em obras, entre o Bosque do Trabalhador e os bairros Sítio Cercado, Pinheirinho e Capão Raso",
  credito: "Loteamento Neoville, autoria não identificada, domínio público",
  pagina: "https://commons.wikimedia.org/wiki/File:Neoville_fotoaerea_1.jpg",
};

export const FOTO_RUA = {
  src: `${BASE}/sobre/boca-maldita.jpg`,
  alt: "Boca Maldita à noite, na Rua XV de Novembro, com a escultura de pedra, postes acesos e carros passando",
  legenda: "Boca Maldita, na Rua XV de Novembro: ponto tradicional de encontros e manifestações no centro.",
  credito: "Boca Maldita, Marcos pereirah, CC BY-SA 4.0",
  pagina: "https://commons.wikimedia.org/wiki/File:Paisagem_Urbana_do_Trecho_da_Pra%C3%A7a_Os%C3%B3rio,_Avenida_Lu%C3%ADs_Xavier,_Rua_XV_de_Novembro-Boca-Maldita.jpg",
};

export const FOTO_ONIBUS = {
  src: `${BASE}/sobre/onibus-biarticulado.jpg`,
  alt: "Ônibus biarticulado laranja parado no Terminal Cabral, em Curitiba",
  legenda: "Biarticulado no Terminal Cabral. Transporte é um dos temas mais frequentes no mapa.",
  credito: "Ônibus biarticulado, Mateusmatsuda, CC BY 4.0",
  pagina: "https://commons.wikimedia.org/wiki/File:%C3%94nibus_biarticulado_Curitiba_20250603.jpg",
};

export const CREDITOS = [FOTO_CAPA, FOTO_CIDADE, FOTO_RUA, FOTO_ONIBUS];
